import { colorPalette } from "../../utils/constants";

export const customStyles = {
  formLabel: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 500,
    fontSize: "0.95rem",
    mb: 0.5,
    color: colorPalette.black,
  },
  submitButton: {
    backgroundColor: colorPalette.headerBackground,
    color: colorPalette.white,
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 600,
    fontSize: "1.1rem",
    py: 1.5,
    borderRadius: 1,
    textTransform: "none" as const,
    "&:hover": {
      backgroundColor: colorPalette.sectionTitle,
    },
  },
};
